import { Pie } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  Title,
} from 'chart.js';
// import { useDarkMode } from '../../hooks';
import { ChartContainer, ChartWrapper } from './pie-chart.style';

ChartJS.register(Tooltip, Legend, ArcElement, Title);

const PieChart = ({ labels, data, backgroundColors, title, legendPosition }) => {
  // const [isDarkMode] = useDarkMode();

  // const legendColor = isDarkMode ? '#a9a9a9' : '#a9a9a9';
  const legendColor = '#a9a9a9';

  const noDataFound = JSON.stringify(data) === JSON.stringify([1, null, null]);

  const chartData = {
    labels: labels.map(label => label),
    datasets: [
      {
        data: data.map(value => value),
        backgroundColor: backgroundColors.map(color => color),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1,
    // datasets: {
    //   backgroundColor: backgroundColors,
    //   borderWidth: 1,
    // },
    cutout: '70%',
    layout: {
      padding: {
        top: 0,
        right: 0,
        left: 0,
        bottom: 20,
      },
    },
    plugins: {
      legend: {
        position: legendPosition,
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 7,
          boxHeight: 7,
          color: legendColor,
          font: {
            size: 14,
          },
          // padding: 20,
        },
        onClick: noDataFound ? () => { } : undefined,
      },
      tooltip: {
        enabled: !noDataFound,
      },
      datalabels: {
        listeners: noDataFound
          ? {
              click: null,
              enter: null,
              leave: null,
            }
          : {},
      },
      // title: {
      //   display: true,
      //   text: title,
      //   align: 'start', // 'left' alignment
      //   position: 'top',
      //   color: titleColor,
      //   font: {
      //     size: 18,
      //   },
      // },
    },

  };

  return (
    <ChartWrapper className='box-shadow'>
      <ChartContainer>
        {
          title &&
          <h4>{title}</h4>
        }
        <Pie data={chartData} options={options} />
      </ChartContainer>
    </ChartWrapper>
  );
};

PieChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  backgroundColors: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  legendPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default PieChart;
